(function () {
  // The popular terms/products markup ships inside <template> (it is rendered twice, for the mobile and
  // desktop search) so it isn't built on every page load. It goes in when search is about to open, or
  // once the page has settled.
  function inflateAll() {
    document.querySelectorAll('template[data-lazy-search-popular]').forEach(function (template) {
      template.replaceWith(template.content.cloneNode(true));
    });
  }

  ['pointerdown', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest && event.target.closest('.header__search, details-modal, .search-modal, form.search')) inflateAll();
    }, true);
  });
  window.addEventListener('load', function () {
    var later = window.requestIdleCallback || function (fn) { setTimeout(fn, 1); };
    setTimeout(function () {
      later(function () {
        inflateAll();
        setupAll();
      });
    }, 4000);
  });

  function setup(form) {
    var input = form.querySelector('.search__input');
    var defaultState = form.querySelector('[data-predictive-search-default]');
    if (!input || !defaultState) return;
    if (defaultState.dataset.searchPopularBound) return;
    defaultState.dataset.searchPopularBound = 'true';

    var termsSection = defaultState.querySelector('[data-search-terms-section]');

    // Only the "Popular Searches" pills hide once the visitor starts typing.
    // The product carousel itself (data-search-products-section) stays put
    // the whole time -- search-unified.js repopulates it in place with real
    // results instead of swapping in a second, separate results panel.
    function sync() {
      if (termsSection) {
        termsSection.classList.toggle('is-hidden', input.value.trim() !== '');
      }
    }
    sync();
    input.addEventListener('input', sync);
  }

  function setupAll() {
    document.querySelectorAll('form.search').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // Search modals are inside a <details> that Dawn toggles open/closed;
  // re-check state each time one opens (e.g. after the user closed and
  // reopened search with leftover text still in the input).
  document.addEventListener('toggle', function (e) {
    if (e.target.matches('details') && e.target.open) {
      inflateAll();
      setupAll();
      e.target.querySelectorAll('form.search').forEach(function (form) {
        var input = form.querySelector('.search__input');
        var termsSection = form.querySelector('[data-search-terms-section]');
        if (input && termsSection) {
          termsSection.classList.toggle('is-hidden', input.value.trim() !== '');
        }
      });
    }
  }, true);
})();
